var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":"","ma-0":"","fluid":""}},[_c('loading',{attrs:{"active":!_vm.is_data_fetched,"is-full-page":true,"loader":"dots"}}),(_vm.is_data_fetched)?_c('v-layout',{attrs:{"row":"","wrap":"","ma-0":"","justify-center":"","align-content-center":""}},[_vm._v(" Create this page ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }